import React from 'react';
import { BoxProps, Divider, Flex } from '@withjoy/joykit';
import { StyledText } from './ExploreOthers.styles';
import { useCurationsRegistryTranslations } from '../../../Catalog.i18n';
import { useCurationsTree } from '../../../hooks/useCurationsTree';
import { CatalogCurationDictionaryEntry } from '../../../state/Catalog/Catalog.types';
import { CurationCardGrid } from '../../../components/CurationCard';
import { PagesForTelemetry } from '../../..';

interface ExploreOthersProps extends BoxProps {
  isMobile: boolean;
  showSkeleton?: boolean;
  selectedCuration: Maybe<CatalogCurationDictionaryEntry>;
  telemetryPageValue: PagesForTelemetry;
}

const ExploreOthers = React.forwardRef<HTMLDivElement, ExploreOthersProps>(({ isMobile, showSkeleton, selectedCuration, telemetryPageValue, ...restProps }, ref) => {
  const { treeRoot } = useCurationsTree();

  const curations = treeRoot?.children || [];

  const { getSectionsTranslations } = useCurationsRegistryTranslations();
  const { exploreOthersTitle } = getSectionsTranslations();

  const filteredCurations = selectedCuration ? curations.filter(curation => curation.id !== selectedCuration.id) : [];

  return (
    <Flex
      flexDirection="column"
      {...restProps}
      ref={ref}
    >
      <Flex
        margin="0 auto"
        flexDirection="column"
        alignItems="center"
      >
        <StyledText
          component="h1"
          textAlign="center"
        >
          {exploreOthersTitle}
        </StyledText>
        <Divider
          color={'mono6'}
          marginTop={6}
          marginBottom={[6, null, 9]}
        />
        <CurationCardGrid
          curations={filteredCurations}
          showSkeleton={!!showSkeleton}
          telemetryPageValue={telemetryPageValue}
        />
      </Flex>
    </Flex>
  );
});

export { ExploreOthers };
